window.UK_G2_MANUAL_DATA = {
  "manual": {
    "title": "G2 Wi-Fi Gateway manual",
    "hero_title": "G2 Wi-Fi Gateway",
    "product_family": "G2 Wi-Fi Gateway",
    "primary_app": "TTLock",
    "manual_version": "V26.1",
    "lead": "Set up your G2 in TTLock, read its status light and remove it from the app.",
    "app_links": {
      "android_google_play": "https://play.google.com/store/apps/details?id=com.tongtongsuo.app",
      "ios_app_store": "https://apps.apple.com/app/ttlock/id1033046018"
    },
    "checklist": [
      "Connect the G2 to its power supply.",
      "Open TTLock and have your 2.4 GHz Wi-Fi name and password ready.",
      "Check for alternating red and blue before adding the gateway."
    ],
    "quick_specs": {
      "App": "TTLock",
      "Wi-Fi": "2.4 GHz only"
    },
    "search_placeholder": "Search steps, settings or a problem"
  },
  "guides": [
    {
      "handle": "g2-01",
      "title": "Light status description",
      "category": "Preparation",
      "steps": [
        "Observe the LED indicator light on the gateway after powering it on.",
        "Identify the color and flashing pattern of the indicator light.",
        "Refer to the status descriptions below to determine the current device state."
      ],
      "notes": [
        "Red and Blue Alternating Flash: Ready state - the gateway is available to be added and bound by the APP.",
        "Solid Red: Poor network connection - the gateway cannot communicate with the server.",
        "Solid Blue: Normal working status - cannot be bound."
      ],
      "warnings": [],
      "common_mistakes": [
        "Confusing alternating red and blue (ready to add) with solid blue (normal working status, cannot be bound)."
      ],
      "summary": "Understand the meaning of different LED indicator light patterns on the G2 Smart Gateway.",
      "expected_result": "You can correctly identify whether the gateway is in ready state, has poor network connection, or is in normal working status based on the LED indicator behavior.",
      "images": [
        {
          "src": "uk-manual-g2-01-1.webp",
          "alt": "G2 status light: alternating red and blue means ready to add; red means poor network; blue means normal working status."
        }
      ]
    },
    {
      "handle": "g2-02",
      "title": "Bind the gateway to the app",
      "category": "App setup",
      "steps": [
        "Connect the gateway to its power supply.",
        "Open the \"TTLock\" APP on your smartphone.",
        "Tap the “+” button in the upper-right corner of the TTLock home screen.",
        "Select \"G2 (WI-FI)\" from the device list.",
        "Verify the gateway indicator is flashing red and blue alternately, then tap \"Next\".",
        "When the G2 device appears in the search results, tap the \"+\" button next to it.",
        "Tap \"WiFi Name\" to select your available 2.4GHz WiFi network from the list.",
        "Enter your WiFi password accurately.",
        "Enter a recognizable name for your Gateway (e.g., \"Living Room Gateway\").",
        "Tap \"OK\" to complete the binding process.",
        "Wait for the gateway to automatically search for and connect to devices already bound in the APP."
      ],
      "notes": [
        "The screenshots show example device names and network details. Enter your own Wi-Fi password and gateway name."
      ],
      "warnings": [
        "Only 2.4GHz WiFi networks are supported. Ensure your router broadcasts a 2.4GHz signal before proceeding. 5GHz networks will not work with this device."
      ],
      "common_mistakes": [
        "Selecting a 5 GHz Wi-Fi network — the G2 supports 2.4 GHz only.",
        "Entering an incorrect Wi-Fi password.",
        "Trying to add the gateway while the indicator is solid blue instead of alternating red and blue."
      ],
      "summary": "Connect the G2 Smart Gateway to the TTLock APP and configure it for use with your WiFi network.",
      "expected_result": "The gateway indicator turns solid blue, indicating normal working status, and the device appears in your TTLock APP device list ready for use.",
      "images": [
        {
          "src": "uk-manual-g2-bind-01_2x.jpg",
          "alt": "TTLock home screen: tap the + button in the upper-right corner."
        },
        {
          "src": "uk-manual-g2-bind-02_2x.jpg",
          "alt": "Add devices: choose G2 (WI-FI)."
        },
        {
          "src": "uk-manual-g2-bind-03_2x.jpg",
          "alt": "Add Gateway: tap Next when the indicator flashes red and blue alternately."
        },
        {
          "src": "uk-manual-g2-bind-04_2x.jpg",
          "alt": "Choose Gateway: tap + next to the G2 that appears."
        },
        {
          "src": "uk-manual-g2-bind-05_2x.jpg",
          "alt": "Configure Network: choose your 2.4 GHz Wi-Fi, enter its password and a gateway name, then tap OK."
        },
        {
          "src": "uk-manual-g2-bind-06_2x.jpg",
          "alt": "G2 device list: the gateway searches for devices already bound in TTLock."
        }
      ]
    },
    {
      "handle": "g2-03",
      "title": "Delete the gateway",
      "category": "Manage your gateway",
      "steps": [
        "Open TTLock and select the gateway you want to delete.",
        "Check the gateway name so you remove the correct device, then tap “Delete”.",
        "Confirm the deletion when prompted by the app."
      ],
      "notes": [
        "Deletion is a separate task, not part of initial setup."
      ],
      "warnings": [],
      "common_mistakes": [
        "Selecting the wrong gateway — check its name before deleting it.",
        "Leaving the confirmation unfinished — confirm the deletion in the app."
      ],
      "summary": "Remove the selected G2 gateway from your TTLock account. This task is only needed when you want to delete a gateway.",
      "expected_result": "The selected gateway is removed from your TTLock device list.",
      "images": [
        {
          "src": "uk-manual-g2-delete-01_2x.jpg",
          "alt": "Gateways list: select the gateway you want to remove."
        },
        {
          "src": "uk-manual-g2-delete-02_2x.jpg",
          "alt": "Selected gateway: check its name, then tap Delete."
        },
        {
          "src": "uk-manual-g2-delete-03_2x.jpg",
          "alt": "Deletion prompt: confirm removal of the selected gateway."
        }
      ]
    }
  ],
  "troubleshooting": [
    {
      "handle": "g2-red-light",
      "title": "Red light — poor network connection",
      "category": "Network",
      "explanation": "The G2 light guide identifies red as poor network connectivity: the gateway cannot communicate with the server.",
      "symptoms": [
        "The gateway indicator is red."
      ],
      "quick_checks": [
        "During setup, select a 2.4 GHz Wi-Fi network.",
        "Check the Wi-Fi password you enter in TTLock."
      ],
      "fix_steps": [
        "Compare your setup with “Bind the gateway to the app” below.",
        "If the light remains red, contact support with the light pattern and the app screen where you are stuck."
      ],
      "related_guides": [
        "g2-01",
        "g2-02"
      ],
      "support_evidence": [
        "Light colour and flashing pattern",
        "Router model and whether your chosen network is 2.4 GHz",
        "App screenshot with any password hidden"
      ]
    },
    {
      "handle": "g2-wont-add",
      "title": "Gateway won’t add in TTLock",
      "category": "App setup",
      "symptoms": [
        "The G2 does not finish adding to the app."
      ],
      "quick_checks": [
        "Use TTLock and choose G2 (WI-FI).",
        "The indicator must flash red and blue alternately before you tap Next.",
        "Choose a 2.4 GHz Wi-Fi network and check its password."
      ],
      "fix_steps": [
        "Follow the illustrated binding guide and tap + next to the discovered G2.",
        "Enter the Wi-Fi details and gateway name, then tap OK.",
        "If you cannot reach the documented ready state or setup still fails, contact support."
      ],
      "related_guides": [
        "g2-02",
        "g2-01"
      ],
      "support_evidence": [
        "Screenshot of the stage where adding stops",
        "Light colour and pattern",
        "Phone model and TTLock version"
      ]
    },
    {
      "handle": "g2-solid-blue",
      "title": "Solid blue — is the gateway ready to add?",
      "category": "Status light",
      "explanation": "The G2 manual describes solid blue as normal working status. The gateway cannot be bound in this state.",
      "symptoms": [
        "The light is solid blue when you try to add the gateway."
      ],
      "quick_checks": [
        "The ready-to-add signal is alternating red and blue, not solid blue."
      ],
      "fix_steps": [
        "If you only want to check the gateway is working, use the light-status guide.",
        "If you intend to remove a gateway from your account, follow the deletion guide.",
        "Contact support if you cannot access the gateway in TTLock or are unsure which device to remove."
      ],
      "related_guides": [
        "g2-01",
        "g2-03"
      ],
      "support_evidence": [
        "Gateway name shown in TTLock",
        "Light colour and pattern",
        "What you are trying to do: check status, add or remove"
      ]
    },
    {
      "handle": "g2-delete-help",
      "title": "Need help deleting the gateway?",
      "category": "Manage your gateway",
      "symptoms": [
        "You need to remove a G2 gateway from TTLock."
      ],
      "quick_checks": [
        "Check the name of the gateway you have selected."
      ],
      "fix_steps": [
        "Select the gateway, tap Delete, then confirm the deletion.",
        "If the app differs from the illustrated guide or deletion does not complete, contact support with the message shown."
      ],
      "related_guides": [
        "g2-03"
      ],
      "support_evidence": [
        "Screenshot of the selected gateway or error",
        "TTLock app version",
        "Whether the confirmation completed"
      ]
    }
  ],
  "videos": [],
  "support_templates": [
    {
      "title": "Gateway won’t add or shows a red light",
      "subject": "G2 Wi-Fi Gateway — setup or network help",
      "body": "Hi Blusafe team,\n\nI need help with my G2 Wi-Fi Gateway.\n\nOrder number: \nPhone model: \nTTLock version: \nStep where I am stuck: \nLight colour and pattern: \nIs the selected network 2.4 GHz?: \nRouter model: \nMessage shown in TTLock: \n\nI have attached a screenshot of the relevant app screen and, if useful, a short video of the indicator. I have hidden any passwords.\n\nThanks,\n[Your name]"
    },
    {
      "title": "Help removing a gateway",
      "subject": "G2 Wi-Fi Gateway — removal help",
      "body": "Hi Blusafe team,\n\nI need help with my G2 Wi-Fi Gateway.\n\nOrder number: \nPhone model: \nTTLock version: \nGateway name: \nWhat happens after tapping Delete: \nDid the confirmation complete?: \nMessage shown in TTLock: \n\nI have attached a screenshot of the relevant app screen and, if useful, a short video of the indicator. I have hidden any passwords.\n\nThanks,\n[Your name]"
    }
  ],
  "support_email": "enquiries@blusafesolutions.co.uk",
  "search_index": [
    {
      "title": "Light status description",
      "type": "guide",
      "category": "Preparation",
      "anchor": "g2-01",
      "summary": "Understand the meaning of different LED indicator light patterns on the G2 Smart Gateway.",
      "keywords": "['Observe the LED indicator light on the gateway after powering it on.', 'Identify the color and flashing pattern of the indicator light.', 'Refer to the status descriptions below to determine the current device state.'] ['Red and Blue Alternating Flash: Ready state - the gateway is available to be added and bound by the APP.', 'Solid Red: Poor network connection - the gateway cannot communicate with the server.', 'Solid Blue: Normal working status - cannot be bound.'] [] ['Confusing alternating red and blue (ready to add) with solid blue (normal working status, cannot be bound).']   "
    },
    {
      "title": "Bind the gateway to the app",
      "type": "guide",
      "category": "App setup",
      "anchor": "g2-02",
      "summary": "Connect the G2 Smart Gateway to the TTLock APP and configure it for use with your WiFi network.",
      "keywords": "['Connect the gateway to its power supply.', 'Open the \"TTLock\" APP on your smartphone.', 'Tap the “+” button in the upper-right corner of the TTLock home screen.', 'Select \"G2 (WI-FI)\" from the device list.', 'Verify the gateway indicator is flashing red and blue alternately, then tap \"Next\".', 'When the G2 device appears in the search results, tap the \"+\" button next to it.', 'Tap \"WiFi Name\" to select your available 2.4GHz WiFi network from the list.', 'Enter your WiFi password accurately.', 'Enter a recognizable name for your Gateway (e.g., \"Living Room Gateway\").', 'Tap \"OK\" to complete the binding process.', 'Wait for the gateway to automatically search for and connect to devices already bound in the APP.'] ['The screenshots show example device names and network details. Enter your own Wi-Fi password and gateway name.'] ['Only 2.4GHz WiFi networks are supported. Ensure your router broadcasts a 2.4GHz signal before proceeding. 5GHz networks will not work with this device.'] ['Selecting a 5 GHz Wi-Fi network — the G2 supports 2.4 GHz only.', 'Entering an incorrect Wi-Fi password.', 'Trying to add the gateway while the indicator is solid blue instead of alternating red and blue.']   "
    },
    {
      "title": "Delete the gateway",
      "type": "guide",
      "category": "Manage your gateway",
      "anchor": "g2-03",
      "summary": "Remove the selected G2 gateway from your TTLock account. This task is only needed when you want to delete a gateway.",
      "keywords": "['Open TTLock and select the gateway you want to delete.', 'Check the gateway name so you remove the correct device, then tap “Delete”.', 'Confirm the deletion when prompted by the app.'] ['Deletion is a separate task, not part of initial setup.'] [] ['Selecting the wrong gateway — check its name before deleting it.', 'Leaving the confirmation unfinished — confirm the deletion in the app.']   "
    },
    {
      "title": "Red light — poor network connection",
      "type": "troubleshooting",
      "category": "Network",
      "anchor": "g2-red-light",
      "summary": "The G2 light guide identifies red as poor network connectivity: the gateway cannot communicate with the server.",
      "keywords": "    ['During setup, select a 2.4 GHz Wi-Fi network.', 'Check the Wi-Fi password you enter in TTLock.'] ['Compare your setup with “Bind the gateway to the app” below.', 'If the light remains red, contact support with the light pattern and the app screen where you are stuck.'] ['The gateway indicator is red.']"
    },
    {
      "title": "Gateway won’t add in TTLock",
      "type": "troubleshooting",
      "category": "App setup",
      "anchor": "g2-wont-add",
      "summary": "The G2 does not finish adding to the app.",
      "keywords": "    ['Use TTLock and choose G2 (WI-FI).', 'The indicator must flash red and blue alternately before you tap Next.', 'Choose a 2.4 GHz Wi-Fi network and check its password.'] ['Follow the illustrated binding guide and tap + next to the discovered G2.', 'Enter the Wi-Fi details and gateway name, then tap OK.', 'If you cannot reach the documented ready state or setup still fails, contact support.'] ['The G2 does not finish adding to the app.']"
    },
    {
      "title": "Solid blue — is the gateway ready to add?",
      "type": "troubleshooting",
      "category": "Status light",
      "anchor": "g2-solid-blue",
      "summary": "The G2 manual describes solid blue as normal working status. The gateway cannot be bound in this state.",
      "keywords": "    ['The ready-to-add signal is alternating red and blue, not solid blue.'] ['If you only want to check the gateway is working, use the light-status guide.', 'If you intend to remove a gateway from your account, follow the deletion guide.', 'Contact support if you cannot access the gateway in TTLock or are unsure which device to remove.'] ['The light is solid blue when you try to add the gateway.']"
    },
    {
      "title": "Need help deleting the gateway?",
      "type": "troubleshooting",
      "category": "Manage your gateway",
      "anchor": "g2-delete-help",
      "summary": "You need to remove a G2 gateway from TTLock.",
      "keywords": "    ['Check the name of the gateway you have selected.'] ['Select the gateway, tap Delete, then confirm the deletion.', 'If the app differs from the illustrated guide or deletion does not complete, contact support with the message shown.'] ['You need to remove a G2 gateway from TTLock.']"
    }
  ]
};
